module.exports = __webpack_public_path__ + "static/img/manual-56.69670a3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/mobile/manual-56.png
// module id = DJky
// module chunks = 4